import "./OnboardingPage.scss";
import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { UserApi } from "../../services/api/user";

export const ONBOARDING_SOURCES: { value: string; label: string }[] = [
  { value: "YOUTUBE", label: "YouTube" },
  { value: "INSTAGRAM", label: "Instagram" },
  { value: "TIKTOK", label: "Tik-Tok" },
  { value: "TELEGRAM", label: "Telegram" },
  { value: "ADVERTISEMENT", label: "Реклама" },
  { value: "FRIEND_OR_COLLEAGUE", label: "Друг или коллега" },
  { value: "MENTOR", label: "Ментор или наставник" },
  { value: "AWARE_MERCHANTILITY_COMMUNITY", label: "Сообщество «Осознанная меркантильность»" },
  { value: "SEARCH_ENGINE", label: "Нашёл через поисковик" },
  { value: "OTHER_SOCIAL_NETWORKS", label: "Другие социальные сети" },
  { value: "ARTICLE_BLOG_PODCAST", label: "Статья, блог или подкаст" },
  { value: "OTHER", label: "Другое" },
];

export const OnboardingPage = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const toggle = (value: string) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    );
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);

    if (selected.length === 0) {
      setError("Выберите хотя бы один вариант.");
      return;
    }

    try {
      setLoading(true);
      await UserApi.saveOnboardingSource(selected);
      navigate("/app", { replace: true });
    } catch (requestError) {
      const message =
        requestError instanceof Error ? requestError.message : "Не удалось сохранить ответ. Попробуйте еще раз.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header variant="public" />
      <main className="onboarding">
        <section className="onboarding__card">
          <h1 className="onboarding__title">Откуда вы узнали о Neuro Boost?</h1>
          <p className="onboarding__subtitle">Можно выбрать несколько вариантов. Это поможет нам сделать сервис лучше.</p>

          <form className="onboarding__form" onSubmit={(event) => void handleSubmit(event)}>
            <div className="onboarding__options">
              {ONBOARDING_SOURCES.map((source) => (
                <label
                  key={source.value}
                  className={`onboarding__option ${selected.includes(source.value) ? "onboarding__option_selected" : ""}`}
                >
                  <input
                    className="onboarding__checkbox"
                    type="checkbox"
                    name="onboardingSources"
                    value={source.value}
                    checked={selected.includes(source.value)}
                    onChange={() => toggle(source.value)}
                  />
                  <span>{source.label}</span>
                </label>
              ))}
            </div>

            {error ? <p className="onboarding__error">{error}</p> : null}

            <button className="onboarding__submit" type="submit" disabled={loading || selected.length === 0}>
              {loading ? "Подождите..." : "Отправить"}
            </button>
          </form>
        </section>
      </main>
    </>
  );
};